import { __read, __values } from "tslib";
import { BrowserClient, Hub, Severity } from '@sentry/browser';
var client = new BrowserClient({
    dsn: 'https://1baffb2718654e8a859649ae095f6cfa@sentry.wixpress.com/109',
    attachStacktrace: true,
});
export var hub = new Hub(client);
var SHOULD_LOG_TO_SENTRY = process.env.NODE_ENV === 'production' && !(global === null || global === void 0 ? void 0 : global.isStorybook);
var logMessageCounter = 0;
export function logMessage(message, data) {
    var numberedMessage = "[".concat(++logMessageCounter, "] ").concat(message);
    if (SHOULD_LOG_TO_SENTRY) {
        hub.withScope(function (scope) {
            scope.setExtra('extra_data', data);
            hub.captureMessage(numberedMessage, Severity.Debug);
        });
    }
    console.debug(numberedMessage, '\n', data);
}
export function logTaggedMessage(tags) {
    return function (message, data) {
        hub.withScope(function (scope) {
            setTags(tags, scope);
            logMessage(message, data);
        });
    };
}
// Workaround for Sentry@4.
// Here instead of setTags and setExtras from Sentry@5 we use
// setTag and setExtra from Sentry@4 in order to avoid this issue.
export function setTags(tags, scope) {
    var e_1, _a;
    if (scope.setTags) {
        scope.setTags(tags);
    }
    try {
        for (var _b = __values(Object.entries(tags)), _c = _b.next(); !_c.done; _c = _b.next()) {
            var _d = __read(_c.value, 2), key = _d[0], value = _d[1];
            scope.setTag(key, value);
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        }
        finally { if (e_1) throw e_1.error; }
    }
}
//# sourceMappingURL=reporter.js.map